import { useEffect, useState } from 'react';
import BasicInputNumberMask from '../../General/AntComponents/Form/BasicInputNumberMask';
import { stripNonNumeric } from '../../Helpers/Calculations';
import './TextInputStyle.css';

const inputClassName = 'basicinput_de ant-input';
const inputErrorClassName = 'basicinput_de ant-input ant-input-status-error';

//takes an onChange prop and calls it with (dataKey, newValue)
const PhoneInput = props => {
    const { def, dataKey, data, onChange, state, warning } = props;
    const [className, setClassName] = useState(inputClassName);

    useEffect(() => {
        checkPhone(data);
        
    }, [])

    useEffect(() => {
        if (!warning) setClassName(inputClassName);
        else setClassName(inputErrorClassName);
    }, [warning, data])

    const checkPhone = value => {
        const raw = stripNonNumeric(value);

        if (isNaN(raw) && raw !== '') return;
        if (raw.length > 10) return;

        const newWarning = raw.startsWith('0') || raw.startsWith('1')
            ? `"${def.label}" must be a valid phone number that does not start with 0 or 1`
            : raw.length > 0 && raw.length < 10
                ? `"${def.label}" must be 10 digits`
                : '';

        if ((newWarning !== undefined && newWarning !== '') || (state.required && raw.length === 0)) {
            setClassName(inputErrorClassName);
        }
        else {
            setClassName(inputClassName);
        }

        onChange(dataKey, raw, newWarning);
    }

    return <span className='ant-input-wrapper'>
        <BasicInputNumberMask
            className={className}
            id={def.dataKey}
            data-input='phoneinput_de'
            readOnly={state.readonly}
            disabled={state.readonly}
            value={data}
            onChange={(value) => checkPhone(value)}
            useUnmaskedValue={true}
            placeholder={'(___) ___-____'}
            placeholderChar={' '}
            mask={'(000) 000-0000'}
        />
    </span>
}

export default PhoneInput;
